module.exports = __webpack_public_path__ + "static/media/ic_warning.ad80e92c.svg";